import { DEFAULT_TIME_ZONE } from '../../internal/constants';
const browserTimeZone = DEFAULT_TIME_ZONE;
/**
 * @see https://sail.stripe.me/apis/intl/browserTimeZone
 */ export default browserTimeZone;

//# sourceMappingURL=browserTimeZone.js.map